export const preChat = {
  'Open the chat': 'Abrir o chat',
  'Leave the chat': 'Sair do chat',
  Leave: 'Sair',
  'You are chatting as': 'Você está falando como',
  Close: 'Fechar',
  'Tell us your name and cellphone to start the conversation':
    'Informe seu nome e celular para começar a conversa',
  'Full name': 'Nome completo',
  Cellphone: 'Celular',
  PHONE_PLACEHOLDER: '(XX) XXXXX-XXXX',
  'I accept the <1>Terms and conditions</1> and I authorize the use of my data according to the <3>Privacy policy</3>':
    'Aceito os <1>Termos e condições</1> e autorizo o uso de meus dados de acordo com a <3>Declaração de privacidade</3>.',
  'Start conversation': 'Iniciar conversa',
  'This field is required': 'Este campo é obrigatório',
  'Please, inform your name and last name': 'Informe seu nome e sobrenome',
  'Please, inform a valid cellphone': 'Informe um celular válido',
  'Accept the terms to continue': 'Aceite os termos para continuar',
  'Opening the chat...': 'Abrindo o chat...',
  'We could not open the chat now. Try again later or talk to us on WhatsApp':
    'Não conseguimos abrir o chat agora. Tente de novo mais tarde ou fale com a gente pelo WhatsApp.',
};
